module.exports = __webpack_public_path__ + "img/train_icon.4d18fa1f.svg";